import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';
import { z } from 'zod';

import { PageSkeleton } from '~/components/common/page-skeleton/page-skeleton';
import { requireSystemAdmin } from '~/utils/guards';

/** Upload delivery tab landing — the groups list. Super-admin only, like its siblings. */
const UploadDeliveryListPage = lazy(
  () => import('~/features/integrations/pages/upload-delivery-list-page'),
);

// Opaque `?sc=` carries the shared Integrations subsidiary scope (owned by the layout picker).
const searchSchema = z.object({ sc: z.string().optional() });

export const Route = createFileRoute('/_authenticated/_tenant/integrations/upload-delivery/')({
  validateSearch: searchSchema,
  beforeLoad: requireSystemAdmin(),
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <Suspense fallback={<PageSkeleton />}>
      <UploadDeliveryListPage />
    </Suspense>
  );
}
